import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/newhome/title.png'
import _imports_1 from '../../../assets/image/newhome/recommend2.png'
import _imports_2 from '../../../assets/image/newhome/recommend.png'
import _imports_3 from '../../../assets/image/newhome/jiantou.png'
import _imports_4 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-5d47ccd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-5d47ccd9><img src=\"" + _imports_0 + "\" alt=\"\" data-v-5d47ccd9><div class=\"text\" data-v-5d47ccd9>机械原理动画</div><img src=\"" + _imports_0 + "\" alt=\"\" data-v-5d47ccd9></div><div class=\"title1\" data-v-5d47ccd9>汇集设计灵感，体悟机械之美</div>", 2)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "good-title container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "recommend"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "recommend"
}
const _hoisted_9 = { class: "p" }
const _hoisted_10 = {
  key: 2,
  src: _imports_3,
  alt: "",
  class: "jiantou"
}
const _hoisted_11 = { class: "good-list container" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "img-box" }
const _hoisted_14 = {
  key: 0,
  class: "pic-img"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pic-img-3d",
  src: _imports_4
}, null, -1))
const _hoisted_16 = { class: "showtime" }
const _hoisted_17 = { class: "goods-info" }
const _hoisted_18 = { class: "titles" }
const _hoisted_19 = { class: "attrs" }
const _hoisted_20 = { class: "goods-footer" }
const _hoisted_21 = { class: "left" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/icon/play.png" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3VideoPlay = _resolveComponent("vue3VideoPlay")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_carousel, {
        interval: 4000,
        type: "card",
        autoplay: _ctx.autoplay,
        ref: "carousel",
        onChange: _ctx.getIndex
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos.data, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_carousel_item, {
              key: index,
              class: _normalizeClass({
						leftvideo: _ctx.leftvideo(index),
						rightvideo: _ctx.rightvideo(index),
					})
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_vue3VideoPlay, _mergeProps({
                  key: _ctx.options.src,
                  ref_for: true,
                  ref: 'videoPlayer' + index
                }, _ctx.options, {
                  src: item.video,
                  control: _ctx.videoFootShow,
                  onPlay: _cache[0] || (_cache[0] = ($event: any) => (_ctx.star())),
                  onPause: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stop())),
                  onEnded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stop())),
                  poster: item.cover
                }), null, 16, ["src", "control", "poster"]))
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["autoplay", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["title-item", { active: _ctx.isActive == index }]),
          key: index,
          onClick: ($event: any) => (_ctx.active(index))
        }, [
          (index == 0 && _ctx.isActive == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.isActive != 0 && index == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_9, _toDisplayString(item.name), 1),
          (index == _ctx.isActive)
            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
            : _createCommentVNode("", true)
        ], 10, _hoisted_6))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList.datas.data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "goods-item",
          key: index,
          onClick: ($event: any) => (_ctx.goto(item.cid, item.id))
        }, [
          _createElementVNode("div", _hoisted_13, [
            (_ctx.loading)
              ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_14, null, 512)), [
                  [_directive_lazy, _ctx.imgUrl(item.names, item.cover)]
                ])
              : _createCommentVNode("", true),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.videoFormat(item.duration * 1000)), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(item.names), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(item.attr), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(item.click) + "次播放 ", 1)
              ])
            ])
          ])
        ], 8, _hoisted_12))
      }), 128)),
      _createElementVNode("div", {
        class: "more",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goClass()))
      }, "查看更多")
    ])
  ]))
}